import { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../../store';
import { crearSeccionEjercicio } from '../../../../store/slices/seccion-ejercicio';

import { compareEquations } from '../../../../selectors/Ecuaciones';
import { compareNumbers } from '../../../../selectors/Numeros';
import { compareFormulas } from '../../../../selectors/Formula';
import { compareSets } from '../../../../selectors/Conjuntos';
import { compareVectors } from '../../../../selectors/Vector';

import FormularioCrearSM from './FormularioCrearSM';
import { comparePoints } from '../../../../selectors/Punto';
import { compareAntiderivadas } from '../../../../selectors/Antiderivada';


type Props = {
  open: boolean
  setOpen: any
  tipo: string
}

const ModalCrearEjercicio = ({open, setOpen, tipo}: Props) => {

  const dispatch = useDispatch<AppDispatch>();

  const { curso } = useSelector((state: RootState) => state.curso);
  const { seccion } = useSelector((state: RootState) => state.seccion);

  const [enunciado, setEnunciado] = useState('');
  const [respuesta, setRespuesta] = useState('');

  const [error, setError] = useState('');

  useEffect(() => {
    if (error !== '') {
        const timer = setTimeout(() => {setError('');}, 3000);
        return () => clearTimeout(timer);
    }
  }, [error]);

  const handleCrearEjercicio = () => {

    if (enunciado === '') {
      return setError('Ingresa el enunciado del ejercicio')
    }

    if (respuesta === '') {
      return setError('Ingresa la respuesta del ejercicio')
    }

    if (tipo === 'numerico' && compareNumbers(respuesta, respuesta).ok === null) {
      return setError('La respuesta debe ser un número')
    }

    if (tipo === 'punto' && comparePoints(respuesta, respuesta).ok === null) {
      return setError('La respuesta debe ser un punto')
    }

    if (tipo === 'vector' && compareVectors(respuesta, respuesta).ok === null) {
      return setError('La respuesta debe ser un vector')
    }

    if (tipo === 'intervalo' && compareSets(respuesta, respuesta).ok === null) {
      return setError('La respuesta debe ser un intervalo o unión de intervalos')
    }

    if (tipo === 'formula' && compareFormulas(respuesta, respuesta).ok === null) {
      return setError('La respuesta debe ser una fórmula en la variable x')
    }

    if (tipo === 'ecuacionXY' && compareEquations(respuesta, respuesta).ok === null) {
      return setError('La respuesta debe ser una ecuación en las variables x e y')
    }

    if (tipo === 'antiderivada' && compareAntiderivadas(respuesta, respuesta).ok === null) {
      return setError('La respuesta debe ser una antiderivada en la variables x y C')
    }

    if (curso.cid && enunciado !== '' && respuesta !== '') {
      const nuevoEjercicio = {
        cid: curso.cid,
        mid: seccion.mid,
        bid: seccion.bid,
        sid: seccion.sid,
        numero: seccion.ejercicios ? seccion.ejercicios.length + 1 : 1,
        tipo: tipo, 
        enunciado: enunciado, 
        respuesta: respuesta
      }

      dispatch(crearSeccionEjercicio(nuevoEjercicio));
      setOpen(false);
    }
  }

  if (tipo === 'seleccion-multiple') {
    return (
      <Dialog 
        open={open}
        fullWidth
        maxWidth='md'
      >
        <FormularioCrearSM 
          curso={curso}
          seccion={seccion}
          tipo={tipo}
          setOpen={setOpen}
        
        />
      </Dialog>
    )
  }

  if (tipo === 'verdadero-falso') {
    return (
      <div>Verdadero o Falso</div>
    )
  }

  return (
    <Dialog 
      open={open}
      fullWidth
      maxWidth='md'
    >
      <DialogTitle>
        <div className="row justify-content-between">
          <div className="col-auto">
            Crear Ejercicio
          </div>
          <div className="col-auto">
            <code>
              {
                tipo === 'numerico' && 'Número'
              }
              {
                tipo === 'antiderivada' && 'antiderivada'
              }
              {
                tipo === 'conjunto-discreto' && 'Conjunto Discreto'
              }
              {
                tipo === 'vector' && 'Vector con entradas en R'
              }
              {
                tipo === 'intervalo' && 'Intervalo o Unión de Intervalos'
              }
              {
                tipo === 'formula' && 'Fórmula en la variable x'
              }
              {
                tipo === 'ecuacionXY' && 'Ecuación en las variables x e y'
              }
            </code>
          </div>
        </div>
      </DialogTitle>
      <DialogContent>

        {
          error &&
          <div className="alert alert-danger" style={{position: 'absolute', bottom: 5, left: 20, padding: 5 }}>
            {error}
          </div>
        }

        <TextField
          autoFocus
          margin="dense"
          id="name"
          label="Enunciado del Ejercicio"
          // type="email"
          multiline
          rows={10}
          fullWidth
          variant="outlined"
          value={enunciado}
          onChange={(e: any) => setEnunciado(e.target.value)}
          autoComplete="off"
        />

        <TextField
          autoFocus
          margin="dense"
          id="name"
          label="Respuesta del Ejercicio"
          // type="email"
          multiline
          rows={1}
          fullWidth
          variant="outlined"
          value={respuesta}
          onChange={(e: any) => setRespuesta(e.target.value)}
          autoComplete="off"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpen(false)}>Cancelar</Button>
        <Button onClick={() => handleCrearEjercicio()}>Crear</Button>
      </DialogActions>
    </Dialog>
  )

}

export default ModalCrearEjercicio;